'use strict';

var formValidation = require('appCore/components/formValidation');

(function ($) {

  $.fn.daccordion = function (options) {
    if (options == 'openAll') {
      // console.log('I have been told to open all.');
      $(this).find('.collapse-me').show();
      return;
    }
    // console.log("running daccordion");
    // create default settings...
    var settings = $.extend({
      mode: 'single',
      interval: 400,
      collapseClass: 'collapse-me',
      openClass: 'daccordion-is-open',
      closedClass: 'daccordion-is-closed',
      startState: 'closed',
      goToTrigger: 'yes',
      callback: null
    }, options);

    // shorthand for these...
    $.fn.$ac = $.fn.addClass; 
    $.fn.$rc = $.fn.removeClass;

    function selectify(type, text) {
      var marker = '';
      if (type == 'id') {
          marker = '#';
      } else if (type == 'class') { 
          marker = '.';
      }
      return text.indexOf(marker) == 0 ? text : marker + text
    }

    function deSelectify(text) {
      return text.replace(/^(\.|#)/, '');
    }

    function goToElement(element, interval) {
      $('html,body').animate({
          scrollTop: element.offset().top
      }, interval, 'swing'); // think about using a plugin for a cooler easing function
    }

    this.each(function () {
      // console.log("this.each...");
      // initialization
      var $accordion = $(this);
      var $triggers = $accordion.find('[data-collapse-target]').css('cursor', 'pointer');
      var $allTargets = $accordion.find(selectify('class', settings.collapseClass));
      var trOp = deSelectify(settings.openClass);
      var trCl = deSelectify(settings.closedClass);
      // console.log("trOp=" + trOp);
      // console.log("trCl=" + trCl);
      var myInterval = settings.interval;
      if (settings.startState == 'open') {
          $allTargets.show().data('state', 'open');
          $triggers.$ac(trOp).$rc(trCl);
      } else {
          $allTargets.hide().data('state', 'closed');
          $triggers.$ac(trCl).$rc(trOp);
      }
      if ($accordion.data('initialized') != 'yes') {
          // handlers
          if ($triggers.length > 0) {
            $triggers.click(function () {
                var $trigger = $(this);
                var $myTarget = $(selectify('id', $trigger.attr('data-collapse-target')));
                if ($myTarget.data('state') == 'open') {
                  if (settings.mode != 'multi') {
                      $allTargets.slideUp(myInterval).data('state', 'closed');
                      $triggers.$ac(trCl).$rc('ugh');
                  } else {
                      $myTarget.slideUp(myInterval).data('state', 'closed');
                      $trigger.$ac(trCl).$rc(trOp);
                      // if (settings.goToTrigger == 'yes') {
                      // 	goToElement($accordion,myInterval);
                      // }
                  }
                } else {
                  if (settings.mode != 'multi') {
                      $allTargets.slideUp(myInterval).data('state', 'closed');
                      $triggers.$ac(trCl).$rc(trOp);
                      $myTarget.slideDown(myInterval, function () {
                        if (settings.goToTrigger == 'yes') {
                            goToElement($trigger, myInterval);
                        }
                      }).data('state', 'open');
                      $trigger.$ac(trOp).$rc(trCl);
                  } else {
                      $myTarget.slideDown(myInterval, function () {
                        if (settings.goToTrigger == 'yes') {
                            goToElement($trigger, myInterval);
                        }
                      }).data('state', 'open');
                      $trigger.$ac(trOp).$rc(trCl);
                  }
                }
            }); //   /$triggers click
          } //   /if $triggers length > 0
          $accordion.data('initialized', 'yes');
      } else {
          // console.log("handlers already attached");
      } //   /if this initialized
      // finally, make sure the callback is a function before calling it
      if ($.isFunction(settings.callback)) {
          settings.callback.call(this);
      }

    }); //   /this.each
  } //  /protype extension
}(jQuery));

$(document).ready(function() {
  $('.article-accordian-content a.eulacls').click(function (e) {
      e.preventDefault();
      $('#legal-download-modal').modal('show');
      $("#hid_link").attr('href', $(this).attr("href"));
   });

   $("#agree_to_download").click(function (e) {
      //alert("here" + $("#hid_link").attr('href'));
      $('#legal-download-modal').modal('hide');
      //$("#hid_link").trigger("click");
      //$("#hid_link").click();
      window.location = $("#hid_link").attr("href");
   });
  
  $("#support-article-downloads .article-accordian").each(function () {
    $(this).attr('data-collapse-target', $(this).next().attr('id'))
  });

  $('#support-article-downloads').daccordion(); 
});


module.exports = {
    validateFeedback: function () {
        $('.js-article-feedback-form').find('input, select, textarea').each(function () {
            $(this).on('keyup change', function () {
                if (!$(this)[0].checkValidity()) {
                    $(this).trigger('invalid', this.validity);
                } else {
                    $(this).siblings('.invalid-feedback').text('');
                    $(this).removeClass('is-invalid');
                }
            });
        });
    },

    submitFeedback: function () {
        $('body').on('submit', '.js-article-feedback-form', function (e) {
            e.preventDefault();
            var form = $(this);
            var url = form.attr('action');
            var $data = form.serialize();

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $data,
                success: function (data) {
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $('#supportArticleFeedBack').modal('hide');
                        $('.js-support-feedback-form').hide();
                        $('.js-support-article-feedback').html(data.template);

                    }
                },
                error: function (err) {
                    console.log(err);
                }
            });
        });
        return false;
    },
    cancelForm: function () {
        $('.js-feedback-form-cancel').on('click', function () {
            var $textField = $(this).closest('form').find('textarea').first();
            $textField.removeClass('is-invalid');
        });
    }
};
